import { FC, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CenteredContent } from '../components/CenteredContent';
import { AuthStore, BrandStore, RegistrationStore } from '../../context';
import congratulationsImage from '../../assets/img/gogurt/congratulations.png';
import { MainForm } from '../components/application/MainForm';

const StyledSpinner = styled.i`
  font-size: 24px;
  animation: rotate 1.5s linear infinite;
  color: #bdc9cc;
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export const CongratulationsPage: FC = () => {
  const {
    state: { auth },
  } = useContext(AuthStore);
  const {
    state: { registration },
  } = useContext(RegistrationStore);
  const {
    state: { brand },
  } = useContext(BrandStore);
  const token = auth?.token;
  const allowEarlyAccess = brand?.allowEarlyAccess;
  const isPendingMerchant = auth?.merchant?.status === 'PENDING';
  const redirectLink = brand?.selfRegRedirectUrl;
  const [isEarlyAccess, setIsEarlyAccess] = useState(false);

  useEffect(() => {
    if (
      isPendingMerchant &&
      allowEarlyAccess &&
      registration?.signature_status === 'SIGNED'
    ) {
      setIsEarlyAccess(true);
    }
  }, [allowEarlyAccess, isPendingMerchant, registration]);

  useEffect(() => {
    let interval;
    if (isEarlyAccess) {
      interval = setTimeout(() => {
        window.location.href = `${process.env.REACT_APP_OMNI_APP_URL}/#/sso?jwt[]=${token}&building=1`;
      }, 3000);
    } else if (redirectLink && !isEarlyAccess) {
      interval = setTimeout(() => {
        window.location.href = redirectLink;
      }, 3000);
    }
    return () => clearTimeout(interval);
  }, [isEarlyAccess, token, redirectLink]);

  return (
    <MainForm onSubmit={() => {}}>
      <CenteredContent
        id="complete-congratulations"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 100 }}
        exit={{ opacity: 0, y: -20 }}
        $gridTemplateRows={'auto'}
        $align={'center'}
      >
        <div style={{ textAlign: 'center' }}>
          <h2>Congratulations!</h2>
          <div>
            <img
              style={{ width: '200px' }}
              src={congratulationsImage}
              alt={'Congratulations'}
            />
          </div>
          <p>You have successfully submitted your application for review.</p>
          <p>
            <StyledSpinner className="fa fa-spinner" />
          </p>
          <p>
            <small>
              You will now be redirected to Stax Pay where you can begin
              setting up your account.
            </small>
          </p>
        </div>
      </CenteredContent>
    </MainForm>
  );
};
